// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconChevronNext, IconDownload} from '@wandb/weave/components/Icon';
import React, {useCallback, useState} from 'react';

import {ImageExportType} from '../../../util/panelExport';
import {isExportable, isExportableAs} from '../../../util/panels';
import {type getPanelSpec} from '../../../util/panelTypes';
import {usePanelContext} from '../PanelContextProvider';
import {ExportType} from '../types';

type PanelExportMenuProps = {
  ref: React.RefObject<HTMLElement>;
  panelSpec: ReturnType<typeof getPanelSpec>;
  setExportType(type: ExportType): void;
  setImageExportType(imageType: ImageExportType): void;
};

export const PanelExportMenu = React.forwardRef<
  HTMLElement,
  PanelExportMenuProps
>(({panelSpec, setExportType, setImageExportType}, _ref) => {
  const {trackPanelControls} = usePanelContext();
  const onExportImageClick = useCallback(
    (imageType: ImageExportType) => {
      setExportType(ExportType.Image);
      setImageExportType(imageType);
      trackPanelControls({
        action: 'Panel exported',
        exportType: imageType,
      });
    },
    [setExportType, setImageExportType, trackPanelControls]
  );

  const onExportClick = useCallback(
    (exportType: ExportType) => {
      setExportType(exportType);
      trackPanelControls({
        action: 'Panel exported',
        exportType: 'csv',
      });
    },
    [setExportType, trackPanelControls]
  );

  const [isOpen, setIsOpen] = useState(false);

  if (!isExportable(panelSpec)) {
    return null;
  }

  return (
    <DropdownMenu.Sub open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.SubTrigger>
        <div className="flex w-full items-center gap-10">
          <IconDownload />
          Download
          <IconChevronNext className="ml-auto text-moon-450" />
        </div>
      </DropdownMenu.SubTrigger>
      <DropdownMenu.Portal>
        {/* zIndex is needed so the dropdown is above the panel in reports */}
        <DropdownMenu.SubContent style={{zIndex: 1}}>
          {isExportableAs(panelSpec, 'csv') && (
            <DropdownMenu.Item
              title="CSV"
              onSelect={() => onExportClick(ExportType.CSV)}>
              CSV
            </DropdownMenu.Item>
          )}
          {isExportableAs(panelSpec, 'image') && (
            <>
              <DropdownMenu.Item
                onSelect={() => onExportImageClick(ImageExportType.PNG)}>
                PNG
              </DropdownMenu.Item>
              <DropdownMenu.Item
                onSelect={() => onExportImageClick(ImageExportType.PDF)}>
                PDF
              </DropdownMenu.Item>
              <DropdownMenu.Item
                onSelect={() => onExportImageClick(ImageExportType.SVG)}>
                SVG
              </DropdownMenu.Item>
            </>
          )}
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  );
});
